<template>
  <div class="app-page">
    <slot />
    <div v-if="hasError" class="app-page__modal">
      <div class="app-page__modal__content">
        <i class="fa fa-exclamation-triangle app-page__modal__icon" />
        <div class="app-page__modal__text" v-if="Array.isArray(error)">
          <li v-for="(e,i) in error" :key="i">
            {{e}}
          </li>
        </div>
        <p class="app-page__modal__text" v-else>{{error}}</p>
        <button class="btn btn-light btn-block" @click="closeError">
          <small class="text-muted">ACEPTAR</small>
        </button>
      </div>
    </div>
    <div v-if="hasInfo" class="app-page__modal">
      <div class="app-page__modal__content">
        <i class="fa fa-info-circle app-page__modal__icon" />
        <p class="app-page__modal__text"><span v-html="info"></span></p>
        <button class="btn btn-light btn-block" @click="closeInfo">
          <small class="text-muted">ACEPTAR</small>
        </button>
      </div>
    </div>
    <div v-if="hasSendLink" class="app-page__modal">
      <div class="app-page__modal__content">
        <i class="fa fa-map-marker-alt app-page__modal__icon" />
        <p class="app-page__modal__text">
          <a :href="sendLink.link" class="btn btn-info btn-block" target="_blank">
            {{sendLink.title}}
          </a>
        </p>
        <button class="btn btn-light btn-block" @click="closeSendLink">
          <small class="text-muted">ACEPTAR</small>
        </button>
      </div>
    </div>
    <ConditionsPopup v-if="showConditions" />
  </div>
</template>

<script>
import ConditionsPopup from '../Conditions/ConditionsPopup'

export default {
  components: {
    ConditionsPopup
  },
  computed: {
    showConditions() {
      return this.$store.state.showConditions
    },
    hasInfo() {
      return this.$store.state.info && this.$store.state.info !== ''
    },
    info() {
      return this.$store.state.info
    },
    hasSendLink() {
      return this.$store.state.sendLink && this.$store.state.sendLink !== ''
    },
    sendLink() {
      return this.$store.state.sendLink
    },
    hasError() {
      return this.$store.state.error && this.$store.state.error !== ''
    },
    error() {
      return this.$store.state.error
    }
  },
  methods: {
    closeInfo() {
      this.$store.commit('setInfo', null)
    },
    closeSendLink() {
      this.$store.commit('setSendLink', null)
    },
    closeError() {
      this.$store.commit('setError', null)
    }
  }
}
</script>


<style lang="scss">
.app-page {
  background-color: #f2f2f2;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.32);
  flex: 1;
  margin: 38px auto 0 auto;
  max-width: 610px;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 1rem;
  @media screen and (max-width: 340px) {
    font-size: 0.82rem !important;
  }

  &__modal {
    align-items: center;
    background-color: rgba(0, 0, 0, 0.42);
    bottom: 0;
    display: flex;
    justify-content: center;
    left: 0;
    right: 0;
    text-align: center;
    text-transform: uppercase;
    position: fixed;
    top: 0;
    z-index: 10000000;

    &__content {
      background-color: white;
      border-radius: 0.32rem;
      padding: 1rem;
      width: 80%;
    }

    &__icon {
      font-size: 2rem;
      margin-bottom: 1rem;
    }

    &__text {
      background-color: #f2f2f2;
      font-size: 0.96rem;
      padding: 1.42rem 1rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Layout/AppPage.vue